import _ from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FuelContractContainer from '../../containers/inventory/FuelContract';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/Button';

import FMPText from '../../components/pureForm/FMPText';
import FormComponent from '../../components/FormComponent';
import Button from '@material-ui/core/Button';
import FMPQuarterPicker from '../../components/pureForm/FMPQuarterPicker';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import DeleteIcon from '@material-ui/icons/Delete';
import ResourceUploader from '../../components/form/ResourceUploader';
import FMPTerminalSupplierPicker from '../../components/pureForm/FMPTerminalSupplierPicker';
import FMPProductSelect from '../../components/pureForm/FMPProductSelect';
import FMPBulkCustomerMultiSelect from '../../components/pureForm/FMPBulkCustomerMultiSelect';

import { allProducts } from '../../libs/products';
import documentIcon from '../../images/document.svg';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		infoBox: {
			fontSize: 14,
			alignItems: 'center',
			display: 'flex',
			backgroundColor: '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		infoIcon: {
			color: '#2196F3',
			width: 32,
			height: 32,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 34,
			height: 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
	};
};

class SaveFuelContract extends FormComponent {
	constructor(props) {
		super(props);
		const fuelContractId = _.get(this.props, ['match', 'params', 'fuelContractId']);

		this.state = {
			fuelContractId: fuelContractId ? parseInt(fuelContractId, 10) : undefined,
			isUpdate: fuelContractId,
			formFieldError: {},
			quarter: moment().format('YYYY - [Q]Q'),
			startDate: moment().startOf('quarter').format('YYYY-MM-DD'),
			endDate: moment().endOf('quarter').format('YYYY-MM-DD'),
			resourceIds: [],
			finalCalculatedCosts: [],
			bulkCostBulkCustomerIds: [],
		};
	}

	componentDidMount() {
		const { bulkCustomers, searchBulkCustomers, fuelContract, getFuelContract } = this.props;
		if (_.isEmpty(bulkCustomers)) {
			searchBulkCustomers();
		}

		const { isUpdate, fuelContractId } = this.state;
		this.setupFinalCostsArray();

		if (!isUpdate) {
			return;
		}
		if (!fuelContract) {
			getFuelContract({
				params: { fuelContractIds: [fuelContractId] },
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (_.isUndefined(prevProps.fuelContract) && !_.isUndefined(this.props.fuelContract)) {
			const newState = this.fillForm();
			this.setState(newState);
		}

		const { startDate, endDate } = this.state;
		if (
			(prevState.startDate !== startDate && endDate) ||
			(prevState.endDate !== endDate && startDate)
		) {
			this.setupFinalCostsArray();
		}

		const { quarter } = this.state;
		if (prevState.quarter !== quarter) {
			const quarterMoment = moment(quarter, 'YYYY - Q').startOf('quarter');
			const startDate = moment(quarterMoment).startOf('quarter').format('YYYY-MM-DD');
			const endDate = moment(quarterMoment).endOf('quarter').format('YYYY-MM-DD');
			this.setState({ startDate, endDate });
		}
	}

	setupFinalCostsArray = () => {
		const { startDate, endDate, finalCalculatedCosts } = this.state;

		const indexMoment = moment(startDate);
		const endMoment = moment(endDate);
		const newFinalCalculatedCosts = [];
		while (indexMoment.isBefore(endMoment)) {
			const newStartDate = moment(indexMoment).startOf('month').format('YYYY-MM-DD');
			const newEndDate = moment(indexMoment).endOf('month').format('YYYY-MM-DD');

			let cost = '';
			let bulkCost = '';
			const existing = _.find(finalCalculatedCosts, {
				startDate: newStartDate,
				endDate: newEndDate,
			});
			if (existing) {
				cost = existing.cost || '';
				bulkCost = existing.bulkCost || '';
			}

			newFinalCalculatedCosts.push({
				startDate: newStartDate,
				endDate: newEndDate,
				cost,
				bulkCost,
			});
			indexMoment.add(1, 'month');
		}

		this.setState({ finalCalculatedCosts: newFinalCalculatedCosts });
	};

	fillForm = () => {
		const { fuelContract } = this.props;
		if (!fuelContract) {
			return;
		}

		const newState = {};
		[
			'sourceCustomer',
			'contractNumber',
			'note',
			'productType',
			`quarter`,
			'startDate',
			'endDate',

			'timePeriod',
			'numberOfBarrels',
			'numberOfGallons',
			'paymentTerms',
			'overUnderMarginForNumberOfGallons',

			'provisionalPricing',
			'finalPricing',
			'finalCalculatedCosts',
			'bulkCostBulkCustomerIds',

			'lcfs',
			'rins',
			'resourceIds',

			'contractLoadingNumber',
		].forEach((key) => {
			if (_.isNil(fuelContract[key])) {
				return;
			}
			newState[key] = fuelContract[key];
		});

		const { allocatedForTerminalId, supplierForTerminalId } = fuelContract;
		newState.terminalSupplier = {
			terminalId: allocatedForTerminalId,
			supplierId: supplierForTerminalId,
		};

		return newState;
	};

	handleSave = () => {
		const { showErrors, addFuelContract, updateFuelContract } = this.props;
		const { isUpdate, fuelContractId } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const {
			sourceCustomer,
			contractNumber,
			note,
			productType,
			quarter,
			startDate,
			endDate,

			timePeriod,
			numberOfBarrels,

			provisionalPricing,
			finalPricing,
			finalCalculatedCosts,
			bulkCostBulkCustomerIds,
			paymentTerms,
			overUnderMarginForNumberOfGallons,

			lcfs,
			rins,
			resourceIds,
			terminalSupplier,
			contractLoadingNumber,
		} = this.state;

		let numberOfGallons = this.state.numberOfGallons;
		if (numberOfGallons && _.isString(numberOfGallons)) {
			numberOfGallons = numberOfGallons.replace(/,/g, '');
			numberOfGallons = parseInt(numberOfGallons, 10);
			if (!_.isNumber(numberOfGallons)) {
				formFieldError.numberOfGallons = 'Number of gallons must be a number';
			}
		}

		if (!_.isObject(terminalSupplier)) {
			formFieldError.terminalSupplier = 'Terminal / Supplier required';
		}

		const allocatedForTerminalId = terminalSupplier.terminalId;
		const supplierForTerminalId = terminalSupplier.supplierId;

		if (!allocatedForTerminalId || !supplierForTerminalId) {
			formFieldError.terminalSupplier = 'Terminal / Supplier required';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			sourceCustomer,
			contractNumber,
			note,
			productType,
			quarter,
			startDate: moment(startDate).format('YYYY-MM-DD'),
			endDate: moment(endDate).format('YYYY-MM-DD'),

			timePeriod,
			numberOfGallons,
			numberOfBarrels,

			provisionalPricing,
			finalPricing,
			finalCalculatedCosts,
			bulkCostBulkCustomerIds,
			paymentTerms,
			overUnderMarginForNumberOfGallons,

			lcfs,
			rins,
			resourceIds,

			allocatedForTerminalId,
			supplierForTerminalId,
			contractLoadingNumber,
		};

		if (!isUpdate) {
			addFuelContract({ params });
		} else {
			params.fuelContractId = fuelContractId;
			updateFuelContract({ params });
		}
	};

	handleUpload = ({ resource }) => {
		const resourceIds = this.state.resourceIds.slice();
		/** @namespace resource.resourceId **/
		resourceIds.push(resource.resourceId);
		this.setState({ resourceIds });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	render() {
		const { classes, fuelContract, resourceMap = {}, bulkCustomers } = this.props;
		const { isUpdate, resourceIds = [] } = this.state;

		if (isUpdate && !fuelContract) {
			return <div>Fetching fuelContract details...</div>;
		}

		const action = isUpdate ? 'Update Fuel Contract ' : 'Add Fuel Contract';
		return (
			<Paper className={classes.paper}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={10} lg={8}>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12}>
								<FMPRegionHeader isTop={true} label={action} />
							</Grid>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Contract'} />
							</Grid>

							<FMPText {...this.setForm(`sourceCustomer`, 'Source Customer', true)} />
							<FMPText {...this.setForm(`contractNumber`, 'Contract Number', true)} />
							<FMPText {...this.setForm(`note`, 'Contracts Notes', false)} multiline="4" />

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Dates'} />
							</Grid>

							<FMPQuarterPicker {...this.setForm(`quarter`, 'Quarter', true)} />
							<FMPDatePicker
								{...this.setForm(`startDate`, 'Start Date', true)}
								format={'M/D/YYYY'}
								md={6}
							/>
							<FMPDatePicker
								{...this.setForm(`endDate`, 'End Date', true)}
								format={'M/D/YYYY'}
								md={6}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Obligation'} />
							</Grid>

							<FMPSelect
								{...this.setForm(`timePeriod`, 'Time Period', true)}
								options={[
									{ display: 'Quarterly', value: 'quarterly' },
									{ display: 'Monthly', value: 'monthly' },
								]}
							/>

							<FMPText {...this.setForm(`numberOfGallons`, 'Number of Gallons', true)} md={6} />
							<FMPText
								{...this.setForm(`numberOfBarrels`, 'Number of Barrels (10mb, 20mb)', true)}
								md={6}
							/>
							<FMPText
								{...this.setForm(
									`overUnderMarginForNumberOfGallons`,
									'+/- Margin (ex: 0%, 5%, as needed)'
								)}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Allocated At'} />
							</Grid>

							<FMPProductSelect
								{...this.setForm(`productType`, 'Product', true)}
								productTypes={_.map(allProducts, ({ value }) => {
									return value;
								})}
							/>

							<FMPTerminalSupplierPicker
								{...this.setForm(`terminalSupplier`, 'Terminal', true, {})}
								productTypes={[this.state.productType]}
							/>

							<FMPText
								{...this.setForm(`contractLoadingNumber`, 'Contract Loading Number')}
								helpText={
									'Leave blank if not required. Used to associate deliveries with correct contract.'
								}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Pricing Description'} />
							</Grid>

							<FMPText
								{...this.setForm(`provisionalPricing`, 'Provisional Pricing Description', true)}
								multiline={2}
							/>

							<FMPText
								{...this.setForm(`finalPricing`, 'Final Pricing Description', true)}
								multiline={2}
							/>

							<FMPText {...this.setForm(`lcfs`, 'LCFS (ex: no/yes)', true)} md={6} />
							<FMPText {...this.setForm(`rins`, 'RINS (ex: no, 1 D6 per gallon)', true)} md={6} />

							<FMPText
								{...this.setForm(
									`paymentTerms`,
									'Payment Terms (ex: 5 Days, N3 from receipt of invoice/EFT)',
									true
								)}
							/>

							{this.renderFinalCosts()}

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Bulk Customers that get bulk cost'} />
							</Grid>

							<FMPBulkCustomerMultiSelect
								{...this.setForm(`bulkCostBulkCustomerIds`, 'Bulk Customers', false, [])}
								bulkCustomers={bulkCustomers}
								multiple={true}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Contract Documents'} />
							</Grid>

							{resourceIds.map((resourceId, i) => {
								const resource = resourceMap[resourceId];
								if (!resource) {
									return <div>Missing resource</div>;
								}

								const { contentType, url } = resource;

								let preview = (
									<div style={{ width: 75, height: 75, backgroundColor: '#ddd' }}>
										<span style={{ fontSize: 14 }}>No preview</span>
										<br />
										<a href={url} target="_blank" rel="noreferrer noopener">
											Download
										</a>
									</div>
								);

								if (contentType) {
									if (contentType.match(/(png|jpg|jpeg|bmp)/)) {
										preview = (
											<img
												alt={`Attachment ${i + 1}`}
												style={{ maxHeight: 175, maxWidth: 175 }}
												src={url}
											/>
										);
									} else if (contentType.match(/(pdf)/)) {
										preview = (
											<object
												data={url}
												style={{ maxHeight: 175, maxWidth: 122 }}
												type="application/pdf"
												width="122"
												height="175"
											>
												<a href={url}>attachment.pdf</a>
											</object>
										);
									}
								}

								return (
									<Grid key={resourceId} container spacing={3} style={{ marginTop: 10 }}>
										<Grid item xs={12} md={12} style={{ display: 'flex' }}>
											<div>{preview}</div>

											<div style={{ display: 'flex', padding: 20 }}>
												<a href={url} target="_blank" rel="noreferrer noopener">
													<div className={classes.documentIcon} />
												</a>
												<div>
													<a href={url} target="_blank" rel="noreferrer noopener">
														<div>
															<strong>Contract Document #{i + 1}</strong>
														</div>
														<div>{contentType}</div>
													</a>
												</div>
											</div>
											<div>
												<IconButton
													style={{ transform: 'translateY(50%)' }}
													color="primary"
													className={classes.button}
													onClick={() => this.removeInput('resourceIds', i)}
												>
													<DeleteIcon />
												</IconButton>
											</div>
										</Grid>
									</Grid>
								);
							})}

							<Grid container spacing={3}>
								<Grid item xs={12} md={6}>
									<ResourceUploader
										name={'resourceIds'}
										label={'Add Contract Document'}
										afterUpload={this.handleUpload}
									/>
								</Grid>
							</Grid>

							<Grid item xs={12} sm={12} style={{ marginTop: 30 }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.submitButton}
									onClick={this.handleSave}
								>
									{action}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Paper>
		);
	}

	renderFinalCosts = () => {
		const { classes } = this.props;
		const { finalCalculatedCosts, startDate, endDate } = this.state;

		if (!startDate || !endDate) {
			return (
				<Grid item xs={12} sm={12}>
					<div className={classes.note}>
						<strong>Note : </strong>You must have a start and end date before you can fill out the
						actual costs.
					</div>
				</Grid>
			);
		}

		if (_.isEmpty(finalCalculatedCosts)) {
			return (
				<Grid item xs={12} sm={12}>
					Costs are empty. Select a start date / end date, save, then refresh.
				</Grid>
			);
		}

		return (
			<>
				<Grid item xs={12} sm={12}>
					<FMPSectionHeader label={'Final Actual Costs'} />
				</Grid>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={3}>
						{finalCalculatedCosts.map((finalCalculatedCost, i) => {
							const { startDate, endDate } = finalCalculatedCost;
							const label = `Station Cost for ${moment(startDate).format('M/D/YY')} Thru ${moment(
								endDate
							).format('M/D/YY')}`;
							const bulkLabel = `Bulk Cost for ${moment(startDate).format('M/D/YY')} Thru ${moment(
								endDate
							).format('M/D/YY')}`;
							const path = `finalCalculatedCosts.${i}.cost`;
							const bulkPath = `finalCalculatedCosts.${i}.bulkCost`;
							return (
								<Fragment key={`finalCalculatedCosts.${i}`}>
									<FMPText
										{...this.setForm(path, label, false)}
										key={path}
										gridProps={{ md: 6 }}
										md={6}
									/>

									<FMPText
										{...this.setForm(bulkPath, bulkLabel, false)}
										key={bulkPath}
										gridProps={{ md: 6 }}
										md={6}
									/>
								</Fragment>
							);
						})}
					</Grid>
				</Grid>
			</>
		);
	};
}

SaveFuelContract.propTypes = {
	classes: PropTypes.object.isRequired,
	addFuelContract: PropTypes.func.isRequired,
	updateFuelContract: PropTypes.func.isRequired,
	getFuelContract: PropTypes.func.isRequired,
	fuelContract: PropTypes.object,

	resourceMap: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), FuelContractContainer, BulkCustomersContainer])(
	SaveFuelContract
);
